// test2182
(2182 && 0);
